@let landAreaFraction = properties.LAND_AREA_FRACTION;
@let userPlan = accessService.userPlan | async;

<h4 class="title">{{ title }}</h4>

<div class="popup-list" [attr.data-cy]="'levels-popup-list'">

  <!-- Show only activeLayer feature when isSeeMoreActive === false -->
  <ng-container *ngIf="!isSeeMoreActive">
    <ng-container *ngIf="(properties | objectToKeyValue: activeLayer) as keyValueArr">
      <p *ngIf="keyValueArr[0]?.value != null; else notAvailable">
        <span *ngIf="(keyValueArr[0] | formatFeature: true) as formattedFeature">

          <app-voters-data-list
            *ngIf="keyValueArr[0].key === PRESIDENTIAL_ELECTIONS_RESULTS2020"
            [properties]="properties"
            [layer]="keyValueArr[0].key">
          </app-voters-data-list>
          <app-voters-data-list
            *ngIf="keyValueArr[0].key === PRESIDENTIAL_ELECTIONS_RESULTS2024"
            [properties]="properties"
            [layer]="keyValueArr[0].key">
          </app-voters-data-list>
          <app-voters-data-list
            *ngIf="keyValueArr[0].key === BIDEN_VS_TRUMP_2020_POPULATION"
            [properties]="properties"
            [layer]="keyValueArr[0].key">
          </app-voters-data-list>
          <app-voters-data-list
            *ngIf="keyValueArr[0].key === HARRIS_VS_TRUMP_2024_POPULATION"
            [properties]="properties"
            [layer]="keyValueArr[0].key">
          </app-voters-data-list>
          <app-voters-data-list
            *ngIf="keyValueArr[0].key === HOUSE_OF_REPRESENTATIVES_ELECTION_RESULTS"
            [properties]="properties"
            [layer]="keyValueArr[0].key">
          </app-voters-data-list>
          <app-voters-data-list
            *ngIf="keyValueArr[0].key === SENATE_ELECTION_2022_RESULTS"
            [properties]="properties"
            [layer]="keyValueArr[0].key">
          </app-voters-data-list>

          <span
            class="feature-content"
            *ngIf="
              keyValueArr[0].key !== PRESIDENTIAL_ELECTIONS_RESULTS2020 &&
              keyValueArr[0].key !== PRESIDENTIAL_ELECTIONS_RESULTS2024 &&
              keyValueArr[0].key !== BIDEN_VS_TRUMP_2020_POPULATION &&
              keyValueArr[0].key !== HARRIS_VS_TRUMP_2024_POPULATION &&
              keyValueArr[0].key !== HOUSE_OF_REPRESENTATIVES_ELECTION_RESULTS &&
              keyValueArr[0].key !== SENATE_ELECTION_2022_RESULTS
            ">
            <span class="feature-name">
              {{ formattedFeature.formattedKey }}:
            </span>
            <span
              class="feature-value"
              [attr.data-cy]="'levels-popup-list-value'">
              {{ formattedFeature.formattedValue }}
            </span>

            <app-feature-tooltip
              *ngIf="
                landAreaFraction != null &&
                landAreaFraction < 0.75 &&
                (activeLevel === H3_RES7_LEVEL_LAYER || activeLevel === H3_RES5_LEVEL_LAYER)
              "
              [fillColor]="'#f4d196'"
              [strokeColor]="WHITE"
              [opacity]="1"
              [clickable]="false"
              [tooltipText]="'This cell is in a body of water and unlikely to be inhabited. However, it falls within the administrative boundaries that extend beyond the land. Therefore, we must include the data from this area to ensure consistency and accuracy in our analysis of administrative regions'"
              [tooltipPosition]="'right'">
            </app-feature-tooltip>

            <!-- Low‐population warning -->
            <app-feature-tooltip
              *ngIf="keyValueArr[0].key === POPULATION && keyValueArr[0].value < 10"
              [fillColor]="'#f4d196'"
              [strokeColor]="WHITE"
              [opacity]="1"
              [clickable]="false"
              [tooltipText]="'Small population. Interpret demographic data carefully'"
              [tooltipPosition]="'right'">
            </app-feature-tooltip>
          </span>

          <!-- Comparison percent -->
          <span
            *ngIf="
              comparisonResults![keyValueArr[0].key] &&
              keyValueArr[0].key !== PRESIDENTIAL_ELECTIONS_RESULTS2020 &&
              keyValueArr[0].key !== PRESIDENTIAL_ELECTIONS_RESULTS2024 &&
              keyValueArr[0].key !== BIDEN_VS_TRUMP_2020_POPULATION &&
              keyValueArr[0].key !== HARRIS_VS_TRUMP_2024_POPULATION &&
              keyValueArr[0].key !== HOUSE_OF_REPRESENTATIVES_ELECTION_RESULTS &&
              keyValueArr[0].key !== SENATE_ELECTION_2022_RESULTS
            "
            class="comparison-text">
            {{ comparisonResults![keyValueArr[0].key] }}
          </span>

        </span>
      </p>
    </ng-container>
  </ng-container>
  <!-- Show all features when isSeeMoreActive === true -->
  <ng-container *ngIf="isSeeMoreActive">
    <ng-container *ngFor="let feature of properties | objectToKeyValue">
      <ng-container *ngIf="feature.key | isFeatureAccessible: (accessService.accessStatus | async)">
        <p *ngIf="(feature | formatFeature: true) as formattedFeature">
          <app-voters-data-list
            *ngIf="
              feature.key === PRESIDENTIAL_ELECTIONS_RESULTS2020 ||
              feature.key === PRESIDENTIAL_ELECTIONS_RESULTS2024 ||
              feature.key === BIDEN_VS_TRUMP_2020_POPULATION ||
              feature.key === HARRIS_VS_TRUMP_2024_POPULATION ||
              feature.key === HOUSE_OF_REPRESENTATIVES_ELECTION_RESULTS ||
              feature.key === SENATE_ELECTION_2022_RESULTS
            "
            [properties]="properties">
          </app-voters-data-list>

          <span
            class="feature-content"
            *ngIf="
              feature.key !== PRESIDENTIAL_ELECTIONS_RESULTS2020 &&
              feature.key !== PRESIDENTIAL_ELECTIONS_RESULTS2024 &&
              feature.key !== BIDEN_VS_TRUMP_2020_POPULATION &&
              feature.key !== HARRIS_VS_TRUMP_2024_POPULATION &&
              feature.key !== HOUSE_OF_REPRESENTATIVES_ELECTION_RESULTS &&
              feature.key !== SENATE_ELECTION_2022_RESULTS
            "
            [ngClass]="activeLayer === feature.key ? 'selected-feature' : ''">
            <span class="feature-name">
              {{ formattedFeature.formattedKey }}:
            </span>
            <span class="feature-value">
              {{ formattedFeature.formattedValue }}
            </span>

            <app-feature-tooltip
              *ngIf="
                landAreaFraction != null &&
                landAreaFraction < 0.75 &&
                (activeLevel === H3_RES7_LEVEL_LAYER || activeLevel === H3_RES5_LEVEL_LAYER)"
              [fillColor]="'#f4d196'"
              [strokeColor]="WHITE"
              [opacity]="1"
              [clickable]="false"
              [tooltipText]="'This cell is in a body of water and unlikely to be inhabited. However, it falls within the administrative boundaries that extend beyond the land. Therefore, we must include the data from this area to ensure consistency and accuracy in our analysis of administrative regions'"
              [tooltipPosition]="'right'">
            </app-feature-tooltip>

            <app-feature-tooltip
              *ngIf="feature.key === POPULATION && feature.value < 10"
              [fillColor]="'#f4d196'"
              [strokeColor]="WHITE"
              [opacity]="1"
              [clickable]="false"
              [tooltipText]="'Small population. Interpret demographic data carefully.'"
              [tooltipPosition]="'right'">
            </app-feature-tooltip></span>

          <span *ngIf="comparisonResults![feature.key] &&
              feature.key !== PRESIDENTIAL_ELECTIONS_RESULTS2020 &&
              feature.key !== PRESIDENTIAL_ELECTIONS_RESULTS2024 &&
              feature.key !== BIDEN_VS_TRUMP_2020_POPULATION &&
              feature.key !== HARRIS_VS_TRUMP_2024_POPULATION &&
              feature.key !== HOUSE_OF_REPRESENTATIVES_ELECTION_RESULTS &&
              feature.key !== SENATE_ELECTION_2022_RESULTS
            "
            class="comparison-text">
            {{ comparisonResults![feature.key] }}
          </span>
        </p>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<ng-template #notAvailable>
  <p>
    <span class="feature-content">
      <span class="feature-name">{{ activeLayer | LayerNameFormatPipe: userPlan }}:</span>
      <span class="feature-value">{{ (colorScaleService.isBeingLoaded | async) ? 'Loading' : 'N/A' }}</span>
      <app-feature-tooltip
        [fillColor]="'#f4d196'"
        [strokeColor]="WHITE"
        [opacity]="1"
        [clickable]="false"
        [tooltipText]="
          (colorScaleService.isBeingLoaded | async)
            ? (activeLayer | LayerNameFormatPipe:userPlan) + ' is being loaded, please wait'
            : (activeLevel | notAvailableWarningPipe:(activeLayer | LayerNameFormatPipe:userPlan))
        "
        [tooltipPosition]="'right'">
      </app-feature-tooltip>
    </span>
  </p>
</ng-template>
